import { ReactNode, useEffect } from 'react';

import { ThemeContext } from './theme-context';

const selectColor = () => {
  const hostname = window.location.hostname;
  if (hostname === 'pro.xceed.me') return 'white';
  if (hostname === 'pro.staging.xceed.me') return 'lime';
  return 'yellow';
};

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const faviconColor = selectColor();
  useEffect(() => {
    const favicon: HTMLLinkElement | null = document.querySelector('link[rel="icon"]');

    if (favicon) {
      favicon.href = `data:image/svg+xml, <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0H0V12H12V0Z" fill="black"/>
        <path d="M6.67249 4.66433C6.67249 5.03422 6.37299 5.33372 6.0031 5.33372C5.63321 5.33372 5.33371 5.03422 5.33371 4.66433V1.31738H1.31736V3.77165C1.31736 5.00411 2.31636 6.00311 3.54883 6.00311C2.31636 6.00311 1.31736 7.00209 1.31736 8.23457V10.6888H5.33371V7.34334C5.33371 6.97345 5.63321 6.67395 6.0031 6.67395C6.37299 6.67395 6.67249 6.97345 6.67249 7.34334V10.6888H10.6888V8.23457C10.6888 7.00209 9.68984 6.00311 8.45736 6.00311C9.68984 6.00311 10.6888 5.00411 10.6888 3.77165V1.31738H6.67249V4.66433Z" fill="${faviconColor}"/>
      </svg>`;
    }
  }, [faviconColor]);

  return <ThemeContext.Provider value={{}}>{children}</ThemeContext.Provider>;
};
